import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useFormik } from "formik";
import { useHistory, useLocation, useParams } from "react-router";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { usePermissionGuardRedirect } from "../../../hooks/usePermissionGuard";
import {
  GetListofModule,
  createProgrammeStudyPath,
  getProgrammeStudyPathDetails,
  getProgrammeStudyPathModuleList,
  updateProgrammeStudyPath,
} from "../../../services/ProgramService";
import PermissionsGate from "../../../utils/permissionGate";
import TableStudyPath from "./TableStudyPath";

const CreateStudyPath = (props) => {
  const {
    versionData= []
  } = props;
  const history = useHistory();
  const { id, type } = useParams();
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const queryProgrammeId = query.get("programmeId");
  const queryType = query.get("type")

  const [disabled, setDisabled] = useState(false);
  const [moduleList, setModuleList] = useState([]);
  const [modalDuration, setModalDuration] = useState([]);
  const [updateData, setUpdateData] = useState(false);
  const [studyPathData1, setStudyPathData1] = useState([]);
  const [studyPathData, setStudyPathData] = useState([]);

  const [foundationalData1, setFoundationalData1] = useState([]);
  const [foundationalData, setFoundationalData] = useState([]);

  const [electiveData1, setElectiveData1] = useState([]);
  const [electiveData, setElectiveData] = useState([]);

  const [pageData, setPageData] = useState({});

  const [totalRows1, setTotalRows1] = useState(0);
  const [totalRows2, setTotalRows2] = useState(0);
  const [totalRows3, setTotalRows3] = useState(0);
  const [totalCredits,setTotalCredits] = useState({core_credits : 0 , foundational_credits : 0,elective_credits : 0})
  const [sortkey, setSortKey] = useState("name");
  const [sortOrder, setSortOrder] = useState("ASC");
  const [triggers, setTriggers] = useState(false)

  const [loading, setLoading] = useState(false);
  const [tableState, setTableState] = useState({
    page: 1,
    perPage: 10,
    sortKey: "name",
    sortOrder: "DESC",
  });
  const [search1, setSearch1] = useState("");
  const [search2, setSearch2] = useState("");
  const [search3, setSearch3] = useState("");
  const [isModified,setIsModified] = useState(false);
  const renderCount = useRef(0);
  const queryVersionId = query.get("versionId");
  useEffect(() => {
    GetListofModule()
      .then((res) => {
        let moduleData = res?.data.map((mod) => ({
          value: mod.Id,
          label: mod.Portal,
        }));
        moduleData.push({ value: 0, label: "None" });
        setModuleList(moduleData);
      })
      .catch((err) => console.log(err));
  }, []);

  usePermissionGuardRedirect(['pmcmedit']);

  useEffect(() => {
    let duration = [];
    for (let i = 1; i <= 52; i++) {
      let obj = { value: i, label: i };
      duration.push(obj);
    }
    setModalDuration(duration);
  }, []);

  const fetchStudyPathData = async (moduleType, cancelTokenSource, search) => {
    const apiData = {
      page: tableState.page,
      limit: tableState.perPage,
      key: tableState.sortKey,
      sort: tableState.sortOrder,
      search: search,
      exportStatus: type == "create" ? "false" : "true",
      programme_id:queryProgrammeId,
      isAssigned: 1,
      module_type: moduleType,
      id: id || 0,
      version_id : queryVersionId
    };

    try {
      const response = await getProgrammeStudyPathModuleList(apiData, {
        cancelToken: cancelTokenSource.token,
      });
      return response.data;
    } catch (error) {
      if (!axios.isCancel(error)) {
        console.error(
          `Error fetching data for module type ${moduleType}:`,
          error
        );
      }
      return [];
    }
  };

  useEffect(() => {
    const cancelTokenSource = axios.CancelToken.source();
    setLoading(true);

    const fetchAllData = async () => {
      try {
        const [coreModules, foundationalModules, electiveModules] =
          await Promise.all([
            fetchStudyPathData(1, cancelTokenSource, search1),
            fetchStudyPathData(2, cancelTokenSource, search2),
            fetchStudyPathData(3, cancelTokenSource, search3),
          ]);
        setStudyPathData(type == "create" ? coreModules?.modules?.data : coreModules?.modules);
        setTotalRows1(type == "create" ? coreModules?.modules?.data : coreModules?.modules);
        setFoundationalData(type == "create" ? foundationalModules?.modules?.data : foundationalModules?.modules);
          setTotalRows2(type == "create" ? foundationalModules?.modules?.data : foundationalModules?.modules);
        setElectiveData(type == "create" ? electiveModules?.modules?.data : electiveModules?.modules);
          setTotalRows3(type == "create" ? electiveModules?.modules?.data : electiveModules?.modules);
          formik.setFieldValue("core_modules",type == "create" ? coreModules?.modules?.data?.map((item) => item.Id) || [] : coreModules?.modules?.map((item) => item.Id) || [])
          formik.setFieldValue("foundational_modules",type == "create" ? foundationalModules?.modules?.data?.map((item) => item.Id) || [] : foundationalModules?.modules?.map((item) => item.Id) || [])
          formik.setFieldValue("elective_modules",type == "create" ? electiveModules?.modules?.data?.map((item) => item.Id) || [] : electiveModules?.modules?.map((item) => item.Id) || [])

      } finally {
        setLoading(false);
      }
    };

    fetchAllData();

    return () => {
      cancelTokenSource.cancel("Component unmounted");
    };
  }, [search1, search2,search1,sortkey,sortOrder,updateData,type]);

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        const res = await getProgrammeStudyPathDetails(id);
        if (!res.data.data && id) {
          Swal.fire({
            icon: "Info",
            title: "Info",
            text: "No record found with this id",
          })
          history.push(`/program-management-center/programmes/versions/study_path?type=table&versionId=${queryVersionId}&programmeId=${queryProgrammeId}`)
        }
        setPageData(res.data?.data);
      } catch (error) {
        console.error(error);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchAllData();
    }
  }, [updateData]);

  const formik = useFormik({
    enableReinitialize: type === "open" || type === "duplicate" || queryType === "open" ? true : false,
    initialValues: {
      programme_id: queryProgrammeId,
      name: pageData?.name ? pageData.name : "",
      core_credits: pageData?.core_credits != null && pageData?.core_credits != undefined ? pageData.core_credits : "",
      foundational_credits: pageData?.foundational_credits != null && pageData?.foundational_credits != undefined
        ? pageData.foundational_credits
        : "",
      elective_credits: pageData?.elective_credits != null && pageData?.elective_credits != undefined
        ? pageData.elective_credits
        : "",
      core_modules: studyPathData?.map(item => item.Id) || [],
      foundational_modules:  foundationalData?.map(item => item.Id) || [],
      elective_modules:  electiveData?.map(item => item.Id) || [],
    },

    validationSchema: Yup.object({
      name: Yup.string()
        .required("Name is required")
        .max(255, "Name should not be greater than 255 Character")
        .trim(),
      core_credits: Yup.string()
        .required("Core credits is required")
        .max(255, "Core credits should not be greater than 255 Character")
        .trim()
    .test(
      'max-credits',
      'Core credits cannot exceed total module credits',
      function(value) {
        // Parse the input value to a number
        const inputCredits = parseFloat(value);
        
        // Access the core credits from totalCredits state
        const totalModuleCredits = totalCredits?.core_credits || 0;
        
        // Check if input credits exceed total module credits
        return inputCredits <= totalModuleCredits;
      }
    ),
      foundational_credits: Yup.string()
        .required("Foundational credits is required")
        .max(
          255,
          "Foundational credits should not be greater than 255 Character"
        )
        .trim()
        .test(
          'max-credits',
          'Foundational credits cannot exceed total module credits',
          function(value) {
            // Parse the input value to a number
            const inputCredits = parseFloat(value);
            
            // Access the core credits from totalCredits state
            const totalModuleCredits = totalCredits?.foundational_credits || 0;
            
            // Check if input credits exceed total module credits
            return inputCredits <= totalModuleCredits;
          }
        ),
      elective_credits: Yup.string()
        .required("Specialised credits is required")
        .max(255, "Specialised credits should not be greater than 255 Character")
        .trim()
        .test(
          'max-credits',
          'Specialised credits cannot exceed total module credits',
          function(value) {
            // Parse the input value to a number
            const inputCredits = parseFloat(value);
            
            // Access the core credits from totalCredits state
            const totalModuleCredits = totalCredits?.elective_credits || 0;
            
            // Check if input credits exceed total module credits
            return inputCredits <= totalModuleCredits;
          }
        ),
    }),
    onSubmit: (values) => {
      setDisabled(true);
      if (type === "open" || queryType === "open") {
        updateProgrammeStudyPath({ ...values, id: id, version_id : queryVersionId})
          .then(() => {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: "Updated Successfully",
            });
            setDisabled(false);
            history.push(
              `/program-management-center/programmes/versions/study_path?type=table&versionId=${queryVersionId}&programmeId=${queryProgrammeId}`
            );
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: err.response.data,
            });
            setDisabled(false);
          });
      } else {
        createProgrammeStudyPath({...values,version_id : queryVersionId})
          .then((res) => {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: "Added Successfully",
            });
            history.push(
              `/program-management-center/programmes/versions/study_path?type=table&versionId=${queryVersionId}&programmeId=${queryProgrammeId}`
            );
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: err?.response?.data?.message || "Something went wrong",
            });
          });
      }
    },
  });

  const handleSort = (column, sortDirection) => {
    setSortKey(column.selector);
    setSortOrder(sortDirection === "asc" ? "ASC" : "DESC");
  };

  useEffect(() => {
    renderCount.current += 1;
  
    if (renderCount.current <= 4) {
      // For first 4 renders, keep it false
      setIsModified(false);
    } else {
      // On 5th render and beyond, set to true when data changes
      setIsModified(true);
    }
  }, [studyPathData, foundationalData, electiveData]);


  return (
    <div className="card card-profile-info-card">
      <div className="">
        <div className="card-body-inr card-body-info">
          <form onSubmit={formik.handleSubmit}>
            <div className="row">
              <div className="col-md-12">
                <div className="new-card-header">
                  <div className="card-header">Details</div>
                </div>
              </div>
              <div className="col-md-12 col-lg-12">
                <div className="form-group-blk mb-3">
                  <label>Phase Name *</label>
                  <input
                    type="text"
                    className={
                      "form-control" +
                      (formik.errors.name && formik.touched.name
                        ? " is-invalid"
                        : "") + (versionData?.lock_version_settings ? " block-action" : "")
                    }
                    placeholder="Enter phase name"
                    name="name"
                    id="name"
                    title="Phase Name"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={versionData?.lock_version_settings}
                  />
                </div>
              </div>
              <TableStudyPath
                versionData={versionData}
                handleSort={handleSort}
                triggers={triggers}
                setTriggers={setTriggers}
                tableData={studyPathData}
                setTableData={setStudyPathData}
                tableData1={studyPathData1}
                setTableData1={setStudyPathData1}
                search={search1}
                setSearch={setSearch1}
                formik={formik}
                loading={loading}
                modelID={"addModules1"}
                label={"Core Modules"}
                name={"core_credits"}
                module_type={1}
                totalRows={totalRows1}
                ArrayFields={"core_modules"}
                setTotalCredits={setTotalCredits}
              />
              <TableStudyPath
                versionData={versionData}
                handleSort={handleSort}
                triggers={triggers}
                setTriggers={setTriggers}
                tableData={foundationalData}
                setTableData={setFoundationalData}
                tableData1={foundationalData1}
                setTableData1={setFoundationalData1}
                search={search2}
                setSearch={setSearch2}
                formik={formik}
                loading={loading}
                modelID={"addModules2"}
                label={"Foundational Modules"}
                name={"foundational_credits"}
                module_type={2}
                totalRows={totalRows2}
                ArrayFields={"foundational_modules"}
                setTotalCredits={setTotalCredits}
              />

              <TableStudyPath
                versionData={versionData}
                handleSort={handleSort}
                triggers={triggers}
                setTriggers={setTriggers}
                tableData={electiveData}
                setTableData={setElectiveData}
                tableData1={electiveData1}
                setTableData1={setElectiveData1}
                search={search3}
                setSearch={setSearch3}
                formik={formik}
                loading={loading}
                modelID={"addModules3"}
                label={"Specialised Modules"}
                name={"elective_credits"}
                module_type={3}
                totalRows={totalRows3}
                ArrayFields={"elective_modules"}
                setTotalCredits={setTotalCredits}
              />
            </div>
            <div className="form-group form-group-save-cancel mt-4">
              
            <PermissionsGate scopes={[type == "open" ? 'pmcstudypathedit' : "pmcstudypathadd"]} RenderError={() => {
              return (<button
              className="btn btn-save btn-success"
              title="Save"
              disabled
              >
                <i className="fal fa-save"></i> Save
                </button>)
            }}>

              <button
                className="btn btn-save btn-success"
                type="submit"
                title="Save"
                disabled={versionData?.lock_version_settings ? true : (disabled || (type == "open" && !formik.dirty && !isModified))}
                >
                {disabled ? (
                  <i className="fas fa-cog fa-spin"></i>
                ) : (
                  <i className="fal fa-save"></i>
                )}
                Save
              </button>
                </PermissionsGate>
              <button
                className={`btn btn-close btn-danger ${versionData?.lock_version_settings ? "block-action" : ""}`}
                type="button"
                title="Cancel"
                disabled={versionData?.lock_version_settings}
                onClick={() => {
                  if(queryProgrammeId && queryType !== "create") {
                    formik.resetForm();
                    setUpdateData(!updateData)
                  } else {
                    history.goBack();
                  }
                }}
              >
                <i className="fal fa-times"></i>Cancel
              </button>
            </div>

            {Object.keys(formik.values).map((key) => {
              if (formik.touched[key] && formik.errors[key]) {
                return (
                  <div className="invalid-feedback d-block">
                    {formik.errors[key]}
                  </div>
                );
              }
            })}
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateStudyPath;
